import { lazy, Suspense, useState } from "react";
import { QrCode } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { qrError } from "@/components/QrLogin";
import { tx } from "@/content/ContentContext";

const CameraOverlay = lazy(() => import(/* webpackChunkName: "camera-scanner" */ "@/components/scan/CameraOverlay"));

// Phone side of QR login: scanning a valid desktop code logs that computer in as this user (no approval step).
export function ScanLoginButton() {
  const [open, setOpen] = useState(false);
  const onDetect = async (code) => {
    try {
      const { data } = await api.post("/auth/qr/scan", { code });
      const msg = tx("login.qr_logged_in", { device: data.device.label });
      toast.success(msg);
      return { ok: true, label: msg };
    } catch (e) {
      return { ok: false, label: qrError(e) };
    }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="scan-to-login-button" title={tx("login.qr_scan_button")} aria-label={tx("login.qr_scan_button")}
        className="grid h-10 w-10 shrink-0 place-items-center rounded-lg text-slate-400 transition-colors hover:bg-white/10 hover:text-white">
        <QrCode className="h-[18px] w-[18px]" />
      </button>
      {open && (
        <Suspense fallback={null}>
          <CameraOverlay title={tx("login.qr_scan_button")} square hint={tx("login.qr_scan_hint")} onDetect={onDetect} onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </>
  );
}
